import React from "react";
import {
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import Layout from "../components/Layout";
import { AuthProvider } from "../context/AuthContext";
import { SolarStationFormProvider } from "../context/FormContext";
import Dashboard from "../pages/dashboard/Dashboard";
import Login from "../pages/login/Login";
import AddBlob from "../pages/managements/blog/AddBlog";
import Blobb from "../pages/managements/blog/Blog";
import EditBlob from "../pages/managements/blog/EditBlog";
import AddCompany from "../pages/managements/company/AddCompany";
import Company from "../pages/managements/company/Company";
import EditCompany from "../pages/managements/company/EditCompany";
import AddProduct from "../pages/managements/products/AddProduct";
import EditProduct from "../pages/managements/products/EditProduct";
import AddAttribute from "../pages/managements/attribute/AddAttribute";
import Question from "../pages/managements/question/Question";
import AddQuestion from "../pages/managements/question/AddQuestion";
import EditQuestion from "../pages/managements/question/EditQuestion";
import Products from "../pages/managements/products/Products";
import AddUser from "../pages/managements/user/AddUser";
import EditUser from "../pages/managements/user/EditUser";
import User from "../pages/managements/user/User";
import AddVendor from "../pages/managements/vendor/AddVendor";
import EditVendor from "../pages/managements/vendor/EditVendor";
import Vendor from "../pages/managements/vendor/Vendor";
import Attribute from "../pages/managements/attribute/Attribute";
import EditAttribute from "../pages/managements/attribute/EditAttribute";
import Profile from "../pages/profile/Profile";
// import Register from "../pages/register/Register";
import { loginSchema, registrationSchema } from "../utils/validationSchema";
import PrivateRoute from "./privateRoutes";
import PublicRoute from "./publicRoutes";
import Services from "../pages/managements/services/Services";
import AddService from "../pages/managements/services/AddService";
import EditService from "../pages/managements/services/EditService";
import ContactUs from "../pages/managements/contactus/ContactUs";
import BlogCategory from "../pages/managements/blog/categories/BlogCategory";
import AddBlogCategory from "../pages/managements/blog/categories/AddBlogCategory";
import EditBlogCategory from "../pages/managements/blog/categories/EditBlogCategory";
import ProductCategory from "../pages/managements/products/category/ProductCategory";
import AddProductCategory from "../pages/managements/products/category/AddProductCategory";
import EditProductCategory from "../pages/managements/products/category/EditProductCategory";
import News from "../pages/managements/news/News";
import Videos from "../pages/managements/videos/Videos";
import AddNews from "../pages/managements/news/AddNews";
import EditNews from "../pages/managements/news/EditNews";
import AddVideo from "../pages/managements/videos/AddVideo";
import EditVideo from "../pages/managements/videos/EditVideo";
import NewsComments from "../components/commonComponent/NewsComments";
import Reviews from "../pages/Reviews/Reviews";
import Requirement  from "../pages/requirement/Requirement";
import Marketplace from "../pages/managements/marketplaces/Marketplace";
import AddEditMarketplace from "../pages/managements/marketplaces/AddEditMarketplace";
import Interview from "../pages/managements/interviews/Interview";
import Editinterview from "../pages/managements/interviews/Editinterview";
import Sitemap from "../pages/managements/sitemap/Sitemap";
import AddSitemap from "../pages/managements/sitemap/addSitemap";
import EditOffers from "../pages/managements/offers/EditOffers";
import AddOffers from "../pages/managements/offers/AddOffers";
import Offers from "../pages/managements/offers/Offers";
import AddMarketplace from "../pages/managements/products/AddMarketplace";
import Ads from "../pages/ads/Ads";
import AddAds from "../pages/ads/AddAds";
import EditAds from "../pages/ads/EditAds";
// import Testimonial from "../pages/managements/testimonial/testimonial";
import TestiMonial from "../pages/managements/testimonial/testimonial";
import Editestimonial from "../pages/managements/testimonial/EditTestimonial";
import DynamicPages from "../pages/dynamic-pages/DynamicPages";
import GenerateTemplate from "../pages/managements/blog/GenerateTemplate";
import BannerManager from "../pages/managements/banner/banner-manager";
import HeaderLinksManager from "../menu/HeaderLinksManager";

import AdminEditorPage from "../pages/AdminEditorPage"; 


const AppRouter = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <PublicRoute>
                <SolarStationFormProvider schema={loginSchema}>
                  <Login />
                </SolarStationFormProvider>
              </PublicRoute>
            }
          />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <SolarStationFormProvider schema={loginSchema}>
                  <Login />
                </SolarStationFormProvider>
              </PublicRoute>
            }
          />
          {/* <Route
            path="/register"
            element={
              <PublicRoute>
                <SolarStationFormProvider schema={registrationSchema}>
                  <Register />
                </SolarStationFormProvider>
              </PublicRoute>
            }
          /> */}
          <Route
            path="/home"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />

             {/* <Route
            path="/editor"
            element={
              <PrivateRoute>
                <Layout>
                  <EditorPage  />
                </Layout>
              </PrivateRoute>
            }
          /> */}


          <Route
            path="/page-builder"
            element={
              <PrivateRoute>
                <Layout>
                  <AdminEditorPage />
                </Layout>
              </PrivateRoute>
            }
          />




          {/* <Route
            path="/news"
            element={
              <PrivateRoute>
                <Layout>
                  <News />
                </Layout>
              </PrivateRoute>
            }
          /> */}
          {/* <Route
            path="/videos"
            element={
              <PrivateRoute>
                <Layout>
                  <Videos />
                </Layout>
              </PrivateRoute>
            }
          /> */}
           <Route
            path="/contactus"
            element={
              <PrivateRoute>
                <Layout>
                  <ContactUs />
                </Layout>
              </PrivateRoute>
            }
          />
          
           <Route
            path="/Comments"
            element={
              <PrivateRoute>
                <Layout>
                  <NewsComments />
                </Layout>
              </PrivateRoute>
            }
          />
           <Route
            path="/reviews"
            element={
              <PrivateRoute>
                <Layout>
                  <Reviews />
                </Layout>
              </PrivateRoute>
            }
          />
           <Route
            path="/requirement"
            element={
              <PrivateRoute>
                <Layout>
                  <Requirement  />
                </Layout>
              </PrivateRoute>
            }
          />
           <Route
            path="/marketplace"
            element={
              <PrivateRoute>
                <Layout>
                  <Marketplace  />
                </Layout>
              </PrivateRoute>
            }
          />
           <Route
            path="/marketplace/add"
            element={
              <PrivateRoute>
                <Layout>
                  <AddEditMarketplace  />
                </Layout>
              </PrivateRoute>
            }
          />
           <Route
            path="/editMarketplace/:id"
            element={
              <PrivateRoute>
                <Layout>
                  <AddEditMarketplace  />
                </Layout>
              </PrivateRoute>
            }
          />
           <Route
            path="/reviews"
            element={
              <PrivateRoute>
                <Layout>
                  <Reviews />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/profile/:id"
            element={
              <PrivateRoute>
                <Layout>
                  <Profile />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/userManagement"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<User />} />
            <Route path="add" element={<AddUser />} />
            <Route path="edit/:id" element={<EditUser />} />
          </Route>

          <Route
            path="/blogManagement"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
             
            <Route index element={<Blobb />} />
            <Route path="add" element={<AddBlob />} />
            <Route path="edit/:id" element={<EditBlob />} />
          </Route>

            <Route
            path="/generatetemplate"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<GenerateTemplate />} />
          </Route>


          <Route
            path="/blog-category"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>

              
            }
          >
            <Route index element={<BlogCategory />} />
            <Route path="add" element={<AddBlogCategory />} />
            <Route path="edit/:id" element={<EditBlogCategory />} />
          </Route>

          <Route
            path="/product-category"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<ProductCategory />} />
            <Route path="add" element={<AddProductCategory />} />
            <Route path="edit/:id" element={<EditProductCategory/>} />
          </Route>


          <Route
            path="/sitemap"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<Sitemap/>} />
            <Route path="add" element={<AddSitemap/>} />
          </Route>
          <Route
            path="/offers"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<Offers/>} />
            <Route path="add" element={<AddOffers/>} />
            <Route path="edit/:id" element={<EditOffers/>} />
          </Route>

          <Route
            path="/companyManagement"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<Company />} />
            <Route path="add" element={<AddCompany />} />
            <Route path="edit/:id" element={<EditCompany />} />
          </Route>

          <Route
            path="/vendors"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<Vendor />} />
            <Route path="add" element={<AddVendor />} />
            <Route path="edit/:id" element={<EditVendor />} />

          </Route>
          <Route
            path="/news"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<News />} />
            <Route path="add" element={<AddNews />} />
            <Route path="edit/:id" element={<EditNews />} />
          </Route>
          <Route
            path="/interview"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<Interview />} />
            <Route path="add" element={<Editinterview />} />
            <Route path="edit/:id" element={<Editinterview />} />
          </Route>
          <Route
            path="/testimonial"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<TestiMonial/>} />
            <Route path="add" element={<Editestimonial />} />
            <Route path="edit/:id" element={<Editestimonial />} />
          </Route>


          <Route
            path="/dynamic-pages"
            element={
              <PrivateRoute>
                <Layout>
                  <DynamicPages />
                </Layout>
              </PrivateRoute>
            }
          />


          <Route
            path="/banner-manager"
            element={
              <PrivateRoute>
                <Layout>
                  <BannerManager />
                </Layout>
              </PrivateRoute>
            }
          />


          <Route
            path="/header-links-manager"
            element={
              <PrivateRoute>
                <Layout>
                  <HeaderLinksManager />
                </Layout>
              </PrivateRoute>
            }
          />





          <Route
            path="/videos"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<Videos />} />
            <Route path="add" element={<AddVideo />} />
            <Route path="edit/:id" element={<EditVideo />} />
          </Route>

          <Route
            path="/products"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<Products />} />
            <Route path="add" element={<AddProduct />} />
            <Route path="edit/:productId" element={<EditProduct />} />
            <Route path="marketplace/:productId" element={<AddMarketplace />} />
          </Route>

          <Route
            path="/attribute"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<Attribute />} />
            <Route path="add" element={< AddAttribute/>} />
            <Route path="edit/:id" element={<EditAttribute />} />
          </Route>

          <Route
            path="/questions"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
          >
            <Route index element={<Question />} />
            <Route path="add" element={<AddQuestion />} />
            <Route path="edit/:id" element={<EditQuestion />} />
          </Route>
          <Route
            path="/services"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
            >
            <Route index element={<Services />} />
            <Route path="add" element={<AddService />} />
            <Route path="edit/:id" element={<EditService />} />
          </Route>
          <Route
            path="/ads"
            element={
              <PrivateRoute>
                <Layout>
                  <Outlet />
                </Layout>
              </PrivateRoute>
            }
            >
            <Route index element={<Ads />} />
            <Route path="add" element={<AddAds />} />
            <Route path="edit/:id" element={<EditAds />} /> 
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default AppRouter;
